import { Checkbox, FormControlLabel, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface BaseObjectFieldsProps {
    enabled: boolean;
    denumire: string;
    onFieldChange: (field: string, value: unknown) => void;
}

export const BaseObjectFields = ({ enabled, denumire, onFieldChange }: BaseObjectFieldsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={enabled}
                        onChange={e => onFieldChange('enabled', e.target.checked)}
                    />
                }
                label=""
            />
            <TextField
                size="small"
                label={t('contracts.itemName')}
                value={denumire}
                onChange={e => onFieldChange('denumire', e.target.value)}
                disabled={!enabled}
                sx={{ minWidth: 150 }}
            />
        </>
    );
};

interface AmountFieldsProps {
    enabled: boolean;
    pretUnitar: number;
    sumainLei: number;
    sumainEuro: number;
    onFieldChange: (field: string, value: unknown) => void;
    afterUnitPrice?: React.ReactNode;
    /** Shows the unit price as computed, without letting the operator override it. */
    lockUnitPrice?: boolean;
    /** Shows the RON/EUR values as computed, without letting the operator override them. */
    lockAmounts?: boolean;
}

export const AmountFields = ({
    enabled,
    pretUnitar,
    sumainLei,
    sumainEuro,
    onFieldChange,
    afterUnitPrice,
    lockUnitPrice = false,
    lockAmounts = false,
}: AmountFieldsProps) => {
    const { t } = useTranslation();

    return (
        <>
            <TextField
                size="small"
                label={t('contracts.unitPrice')}
                type="number"
                value={pretUnitar ?? ''}
                onChange={e => onFieldChange('pretUnitar', Number(e.target.value))}
                disabled={!enabled}
                slotProps={{ input: { readOnly: lockUnitPrice } }}
                sx={{ width: 100 }}
            />
            {afterUnitPrice}
            <TextField
                size="small"
                label={t('contracts.amountLei')}
                type="number"
                value={sumainLei ?? ''}
                onChange={e => onFieldChange('sumainLei', Number(e.target.value))}
                disabled={!enabled}
                slotProps={{ input: { readOnly: lockAmounts } }}
                sx={{ width: 100 }}
            />
            <TextField
                size="small"
                label={t('contracts.amountEur')}
                type="number"
                value={sumainEuro ?? ''}
                onChange={e => onFieldChange('sumainEuro', Number(e.target.value))}
                disabled={!enabled}
                slotProps={{ input: { readOnly: lockAmounts } }}
                sx={{ width: 100 }}
            />
        </>
    );
};
